export default __webpack_public_path__ + "static/Marker_tree-11b10598d53051fc3d33aaf3e6a269c8.svg";